import {
  DeliveryMethodContainerRuleUnitType,
  SupplierRelationshipFulfillmentType,
  SupplierGetResponseType,
  SupplierStorefrontV2GetResponseType,
} from "@sellar-io/api-v2/types";

import { ContextOrderBasketType } from "../../../hooks";

import { LegacyOrderCheckoutType } from "../checkoutV2/lib/types";

import { CheckoutSelectedFulfillmentType } from "..";

export type CheckoutOrderType = {
  OrderItems: {
    Product: {
      id: number;
      availableFrom: Date | null;
      containerType?: string | null;
      unit?: string | null;
      volume?: number | null;
    };
  }[];
};

export type DeliveryMethodType = NonNullable<
  SupplierStorefrontV2GetResponseType["deliveryMethods"]
>[number];

export type CompositeOrderType =
  | ContextOrderBasketType
  | LegacyOrderCheckoutType
  | CheckoutOrderType
  | null
  | undefined;

export type DeliveryMethodConnection =
  | { fulfillmentType: SupplierRelationshipFulfillmentType | null }
  | undefined
  | null;

export const getDeliveryMethodByType = (
  supplierStorefront: SupplierStorefrontV2GetResponseType,
  fulfillmentType: CheckoutSelectedFulfillmentType,
) => {
  return (
    supplierStorefront.deliveryMethods?.find(
      (deliveryMethod) => deliveryMethod.fulfillmentType === fulfillmentType,
    ) ?? null
  );
};

export const isValidContainerUnit = (
  unit: string | null | undefined,
): unit is DeliveryMethodContainerRuleUnitType | null => {
  if (unit === null || unit === undefined) return true;
  return ["gal", "L", "ml", "cl", "pt", "oz", "g", "kg"].includes(unit);
};

export const getDeliveryMethodInitialValue = ({
  connection,
  supplierStorefront,
  supplier,
}: {
  connection: DeliveryMethodConnection;
  supplierStorefront: SupplierStorefrontV2GetResponseType;
  supplier: SupplierGetResponseType;
}): CheckoutSelectedFulfillmentType => {
  const directDeliveryMethod = getDeliveryMethodByType(
    supplierStorefront,
    "direct",
  );
  const sdDeliveryMethod = getDeliveryMethodByType(
    supplierStorefront,
    "sellarDistribution",
  );
  const courierDeliveryMethod = getDeliveryMethodByType(
    supplierStorefront,
    "courier",
  );
  const palletDeliveryMethod = getDeliveryMethodByType(
    supplierStorefront,
    "haulier",
  );

  if (connection?.fulfillmentType === "collection") {
    return "collection";
  }

  if (directDeliveryMethod && connection?.fulfillmentType === "direct") {
    return "direct";
  }

  if (
    sdDeliveryMethod &&
    connection?.fulfillmentType === "sellarDistribution"
  ) {
    return "sellarDistribution";
  }

  if (courierDeliveryMethod && connection?.fulfillmentType === "courier") {
    return "courier";
  }

  if (sdDeliveryMethod) {
    return "sellarDistribution";
  }

  if (directDeliveryMethod) {
    return "direct";
  }

  if (palletDeliveryMethod) {
    return "haulier";
  }

  if (courierDeliveryMethod) {
    return "courier";
  }

  if (supplier.allowCollectionOnCheckout) {
    return "collection";
  }

  return "courier";
};
